// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

//console.log('Entering Test Modal');

import Vue from 'vue';
import Modal from './Modal.vue';
//import '../../../assets/css/bootstrap.min.css';
//import './adminui.css';

Vue.config.productionTip =false

var isIndex = false;
//var spaceKey='No Space Key';
//console.log('SpaceKey has been added');

/* eslint-disable no-new  charly-booo*/
new Vue({ 
  el: '#app',
  data:function(){
return {
  isModalVisible:false
};
  }, 

  components: { 
    'modal-el':Modal
  },
  methods:{
    showModal(){
      this.isModalVisible = true;
  },
  
  closeModal(){
      this.isModalVisible = false;
  }
  }
  ,
  created(){

  }

  
 
})


